import { t } from "ttag";

import { type RouteTab, RouteTabs } from "metabase/common/components/RouteTabs";

import S from "./EntityViewSwitch.module.css";

type EntityView = "group" | "database";

interface EntityViewSwitchProps {
  value: EntityView;
  onChange: (value: string) => void;
}

export const EntityViewSwitch = ({
  value,
  onChange,
}: EntityViewSwitchProps) => {
  const tabs: RouteTab<EntityView>[] = [
    {
      label: t`Groups`,
      value: "group",
      to: "/admin/permissions/data/group",
    },
    {
      label: t`Databases`,
      value: "database",
      to: "/admin/permissions/data/database",
    },
  ];

  return (
    <div className={S.EntityViewSwitchRoot}>
      <RouteTabs
        aria-label={t`Permission view`}
        tabs={tabs}
        value={value}
        variant="pills"
        onChange={onChange}
      />
    </div>
  );
};
